<div mat-dialog-title>
    {{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CREATE_RECORD.GAUDE_TITLE' | translate | uppercase}}
</div>
<div mat-dialog-content>
    <mat-card-content>
        <form [formGroup]="formGroup">
            <mat-form-field class="w100">
                <input #searchInput type="text" matInput formControlName="search" [matAutocomplete]="auto"
                    [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate">
                <div matSuffix class="app-suffix-search-icon-wrapper">
                    <button mat-icon-button (click)="searchStudent()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                    (optionSelected)="selectStudent($event.option.value)">
                    <mat-option *ngFor="let student of options" [value]="student">
                        {{student.campustxt ? student.campustxt + ': ' : ''}}{{student.identificativo}} - {{student.nombre}} {{student.apellido1}}
                        {{student.apellido2}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="formGroup.get('search').hasError('minlength')">
                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.MIN_LENGTH' | translate }}
                </mat-error>
            </mat-form-field>
        </form>

        <mat-card *ngIf="student">
            <mat-card-content>
                <div class="div-wrap">
                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.CAMPUS' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.campustxt"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.ENTITY_ID' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.id_entidad"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.IDENTIFICATION_TYPE' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.tipo_identificativo"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.IDENTIFICATION' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.identificativo"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.SGA' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.sga" [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.NAME' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.nombre"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.LASTNAME_1' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.apellido1"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.GAUDE_FIELDS.LASTNAME_2' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="student.apellido2"
                            [disabled]="true"></textarea>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>

        <div class="spinner-center" *ngIf="loading">
            <mat-spinner></mat-spinner>
        </div>
    </mat-card-content>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="accent">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.NO_LABEL' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="student" [disabled]="student === null || student === undefined"
        color="primary">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.YES_LABEL' | translate }}
    </button>
</div>